import React, { FC, useState } from "react";
import { API_URL } from "../actions/settings";
import NotificationPopUp from "./extras/NotificationPopUp";
import { isStaff } from "./extras/Functions";
import { useAppSelector } from "../Hooks";
import { selectUser } from "../reducers/UserReducer";
import { IonButton, IonIcon, IonSpinner } from "@ionic/react";
import { refreshCircleOutline } from "ionicons/icons";

async function reloadData(id:any,token:any) {

    return fetch(`${API_URL}/energystar/property/${id}/update_cost_avoidance`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      }

    })
    .then((res) => {
        if (res.ok) {
            return true;
        } else {
            res.json().then( err => {
                NotificationPopUp("Error", err.detail||"Internal Error", "Error Reloading Data")
            })
            return false;
        }
      });
   }

   async function reloadEstarData(id:any,token:any) {

    return fetch(`${API_URL}/energystar/property/${id}/update_estar_data`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      }

    })
    .then((res) => {
        if (res.ok) {
            return true;
        } else {
            res.json().then( err => {
                NotificationPopUp("Error", err.detail||"Could not pull data", "Error Reloading Data")
            })
            return false;
        }
      });
   }

async function reloadConsumption(id:any,token:any) {

    return fetch(`${API_URL}/energystar/properties/consumption_data`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      },
      body: JSON.stringify({
        buildings: [id]
      })

    })
    .then((res) => {
        if (res.ok) {
            return true;
        } else {
            NotificationPopUp('error',`Error Reloading Consumption Data`)
            return false;
        }
      });
   }

interface IProps {
    id:any,
    type:string,
    data?:any,
    title?:string,
    style?:any
};

const ReloadDataButton:FC<IProps> = (props) => {
    const [loading,setLoading] = useState(false)
    const user = useAppSelector(selectUser)

    const handleReloadDash = async () => {
            setLoading(true)
            const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
            let res = null
            if(props.type === 'cost_avoidance'){
                res = await reloadData(props.id,token)
            }
            if(props.type === 'consumption'){
                res = await reloadConsumption(props.id,token)
            }
            if(props.type === 'estar_data'){
                res = await reloadEstarData(props.id,token)
            }

            setLoading(false)
            if(res){
                window.location.reload();
            }
        }
    return <div style={props.style ? props.style : {position:'absolute',right:'0', top:'0px'}}>
            {isStaff(user) ?
                <IonButton size="small" color='dark' disabled={loading} title={props.title} onClick={() => handleReloadDash()}>
                    {loading? <IonSpinner name="dots" /> :<IonIcon color="light" size="small" icon={refreshCircleOutline}/>}
                </IonButton>
            : null}
            </div>
};

export default ReloadDataButton;